import {observer} from 'mobx-react';
import moment from 'moment';
import {Modal, ModalButtons} from 'shared/components/modals';
import {DatePicker, FormLayout, Select2} from 'shared/components';
import {t, withState} from 'shared/core';
import {auth} from 'main/tools';
import InterviewInviteModalState from 'main/containers/recruiting/state/InterviewInviteModalState';

const CREATE_NEW_SCHEDULE = 'CREATE_NEW_SCHEDULE';

const ScheduleInterviewModal = observer(({uiState, isOpen, onClose}) => {
  const {interviewInvite, interviewSchedules, scheduleInterviewErrors} = uiState;

  const selectedSchedule = interviewInvite.interviewSchedule;

  const onScheduleChange = value => {
    if (value === CREATE_NEW_SCHEDULE) {
      uiState.createNewInterviewSchedule();
      return;
    }

    const schedule = interviewSchedules.find(s => `${s.id}` === `${value}`);
    uiState.selectInterviewSchedule(schedule);
  };

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => onClose()}
      size='sm'
      title='recruiting.hiring_funnel.Send interview invite'
    >
      <FormLayout>
        <Select2
          label='recruiting.hiring_funnel.Interview schedule'
          placeholder='recruiting.hiring_funnel.Select an interview schedule'
          value={selectedSchedule ? selectedSchedule.id : null}
          onChange={e => onScheduleChange(e.target.value)}
          searchable
        >
          {interviewSchedules.map(schedule =>
            <option key={schedule.id} value={schedule.id}>{schedule.templateName}</option>
          )}
          {auth.hasAccess('::MANAGE_ATS') &&
            <option key='createNewInterviewSchedule' value={CREATE_NEW_SCHEDULE}>
              {t('recruiting.hiring_funnel.+ Create New Interview Schedule')}
            </option>}
        </Select2>
        {selectedSchedule && <DatePicker
          label='recruiting.hiring_funnel.Start date'
          value={moment(interviewInvite.startDate)}
          onChange={date => interviewInvite.startDate = date}
          errorMessage={scheduleInterviewErrors.startDate}
        />}
        {selectedSchedule && <DatePicker
          label='recruiting.hiring_funnel.End date'
          value={moment(interviewInvite.endDate)}
          onChange={date => interviewInvite.endDate = date}
          errorMessage={scheduleInterviewErrors.endDate}
        />}
      </FormLayout>
      <ModalButtons
        onSave={() => uiState.saveInterviewInvite()}
        saveCaption='recruiting.hiring_funnel.Send'
        saveEnabled={!!selectedSchedule}
        onCancel={() => onClose()}
      />
    </Modal>
  );
});

export default withState(ScheduleInterviewModal, InterviewInviteModalState);
